import {
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorExtractorService } from '../../error-handling/error-extractor/error-extractor.service';

// Create a context token for skipping the error interceptor
export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(
  () => false,
);

/**
 * Intercepts HTTP responses and displays error messages from API responses
 * Only one error is displayed at a time
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorExtractor = inject(ErrorExtractorService);

  // Check if this request should skip error handling

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const userMessage = errorExtractor.extractErrorMessage(error);

      // Attached in place rather than spread onto a copy: a spread carries the
      // own properties but drops the prototype, so every downstream
      // `instanceof HttpErrorResponse` would silently evaluate to false.
      return throwError(() => Object.assign(error, { userMessage }));
    }),
  );
};
